'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgTabMoreLeft, SvgTabMoreRight } from '@common/icon';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { PickedGift } from './PickedGift';
import type { WelloPickItem } from './WelloPickSectionServer';
interface WelloPickSectionProps {
  items: WelloPickItem[];
  className?: string;
}
export const WelloPickSection = t0 => {
  const $ = _c(37);
  const {
    items,
    className
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP);
  const t1 = items.length > 1;
  const t2 = isDesktopViewport ? false : true;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      loop: t1,
      align: "start",
      dragFree: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t3);
  const isSwiperReady = Boolean(emblaApi);
  const handleClickItem = _temp;
  const isNotRender = items.length < 1;
  if (isNotRender) {
    return null;
  }
  let t4;
  if ($[3] !== className) {
    t4 = cn("flex flex-col items-center gap-24 px-40 content-container", "mobile-tablet:items-start mobile-tablet:gap-16 mobile-tablet:px-0", className);
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <header className={cn("flex items-center gap-10", "mobile-tablet:gap-4 mobile-tablet:px-20")}><h2 className={cn("font-800 text-Gray-900 typo-h4", "mobile-tablet:font-700 mobile-tablet:typo-body1")}>👀 지금 많이 조회하는 답례품</h2></header>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = !isSwiperReady;
  let t7;
  if ($[6] !== isSwiperReady || $[7] !== t6) {
    t7 = cn("w-fit max-w-full overflow-hidden transition-opacity duration-300", "mobile-tablet:px-20", {
      "opacity-0": t6,
      "opacity-100": isSwiperReady
    });
    $[6] = isSwiperReady;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== items) {
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = item_0 => {
        const isDisplayInstitution = !!item_0.institutionId && !!item_0.institutionName && !!item_0.institutionLogoUrl;
        return <div key={item_0.productNumber} className="mr-12 !w-fit flex-[0_0_auto]"><PickedGift donationAmount={item_0.donationAmount} onClickItem={() => handleClickItem(item_0)} isDisplayInstitution={isDisplayInstitution} imageUrl={item_0.imageUrl} institutionId={item_0.institutionId} institutionSlugId={item_0.institutionSlugId} institutionName={item_0.institutionName} institutionLogoUrl={item_0.institutionLogoUrl} isNew={item_0.isNew} readCount={item_0.readCount} productNumber={item_0.productNumber} slugId={item_0.slugId} productName={item_0.productName} reviewRating={item_0.reviewRating} reviewCount={item_0.reviewCount} /></div>;
      };
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    t8 = items.map(t9);
    $[9] = items;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <div className="flex">{t8}</div>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== emblaRef || $[15] !== t7 || $[16] !== t9) {
    t10 = <div ref={emblaRef} className={t7}>{t9}</div>;
    $[14] = emblaRef;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = cn("absolute -left-26 top-170 z-10 size-fit -translate-y-1/2 p-0", "mobile-tablet:hidden");
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== emblaApi) {
    t12 = () => emblaApi?.scrollPrev();
    $[19] = emblaApi;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SvgTabMoreLeft className="size-52" originalFill={true} />;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t12) {
    t14 = <Button aria-label={"\uC774\uC804"} theme="sub-text" className={t11} onClick={t12}>{t13}</Button>;
    $[22] = t12;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = cn("absolute -right-26 top-170 z-10 size-fit -translate-y-1/2 p-0", "mobile-tablet:hidden");
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== emblaApi) {
    t16 = () => emblaApi?.scrollNext();
    $[25] = emblaApi;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <SvgTabMoreRight className="size-52" originalFill={true} />;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t16) {
    t18 = <Button aria-label={"\uB2E4\uC74C"} theme="sub-text" className={t15} onClick={t16}>{t17}</Button>;
    $[28] = t16;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t10 || $[31] !== t14 || $[32] !== t18) {
    t19 = <div className="relative w-fit max-w-full">{t10}{t14}{t18}</div>;
    $[30] = t10;
    $[31] = t14;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t19 || $[35] !== t4) {
    t20 = <section className={t4}>{t5}{t19}</section>;
    $[34] = t19;
    $[35] = t4;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  return t20;
};
function _temp(item) {
  trackGtmEvent(GTM_EVENT_TYPE.SELECT_ITEM, {
    currency: "KRW",
    value: item.donationAmount,
    local_name: item.institutionName,
    items: [{
      item_type: "\uB2F5\uB840\uD488",
      item_list_name: "\uD648 \uC624\uB298\uC758 \uC6F0\uB85C Pick \uC139\uC158",
      item_list_id: item.productNumber,
      price: item.donationAmount,
      item_name: item.productName,
      quantity: 1,
      item_id: item.productNumber
    }]
  });
}